import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'



const ManagerLevelsViews = lazy(() => import('./ManagerLevelsViews.jsx'));
const CaseDetails = lazy(() => import('./CaseDetails.jsx'));
const CaseClosureApprovals = lazy(() => import('./CaseClosureApprovals.jsx'));
const ActivitiesTakenPage = lazy(() => import('./ActivitiesTakenPage.jsx'));
const CaseTransferApprovals = lazy(() => import('./CaseTransferApprovals.jsx'));



const ManagerLevelsViewsRoutes = [
    {
        path: '/ManagerLevelsViews',
        component: ManagerLevelsViews,
        auth: authRoleAccess.manager_levels_access,
    },
    {
        path: '/ManagerLevelsViews/case/:id',
        component: CaseDetails,
        auth: authRoleAccess.manager_levels_access,
    },
     {
        path: '/ManagerLevelsViews/case-closure-approvals/case/:id',
        component: CaseDetails,
        auth: authRoleAccess.manager_levels_access,
    },
    {
        path: '/ManagerLevelsViews/case-closure-approvals',
        component: CaseClosureApprovals,
        auth: authRoleAccess.manager_levels_access,
    },
    {
        path: '/ManagerLevelsViews/activities-taken/:id',
        component: ActivitiesTakenPage,
        auth: authRoleAccess.manager_levels_access,
    },   
    {
        path: '/ManagerLevelsViews/transfer-approvals',
        component: CaseTransferApprovals,
        auth: authRoleAccess.manager_levels_access,
    },
];

export default ManagerLevelsViewsRoutes
